import * as yup from "yup";

export const passwordRegex = {
    minMax: /^.{8,15}$/,
    uppercase: /[A-Z]/,
    lowercase: /[a-z]/,
    number: /\d/,
    specialChar: /[!@#^*_?{}\-]/,
};

export const changePasswordSchema = yup.object().shape({
    password: yup
        .string()
        .required("New Password is required")
        .matches(passwordRegex.minMax, "Password must be between 8 and 15 characters")
        .matches(passwordRegex.uppercase, "Password must contain at least one uppercase letter")
        .matches(passwordRegex.lowercase, "Password must contain at least one lowercase letter")
        .matches(passwordRegex.number, "Password must contain at least one number")
        .matches(
            passwordRegex.specialChar,
            "Password must contain at least one special character (!@#^*_?{}-)"
        ),
    confirmpassword: yup
        .string()
        .required("Confirm Password is required")
        .oneOf([yup.ref("password")], "Passwords must match"),
});

export const createPasswordSchema = yup.object().shape({
    new_password: yup
        .string()
        .required("New Password is required")
        .matches(passwordRegex.minMax, "Password must be between 8 and 15 characters")
        .matches(passwordRegex.uppercase, "Password must contain at least one uppercase letter")
        .matches(passwordRegex.lowercase, "Password must contain at least one lowercase letter")
        .matches(passwordRegex.number, "Password must contain at least one number")
        .matches(
            passwordRegex.specialChar,
            "Password must contain at least one special character (!@#^*_?{}-)"
        ),
    confirmPassword: yup
        .string()
        .required("Confirm Password is required")
        .oneOf([yup.ref("new_password")], "Passwords must match"),
});

